(() => {
  const storageKey = '52kards.ebook-signin-source';
  const sourceKey = 'k52_signup_source';
  const sourceValue = 'free-ebook';
  const maxAge = 60 * 60 * 1000;
  const getPending = () => {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || 'null');
    } catch (_) {
      return null;
    }
  };
  const clearPending = () => {
    try { localStorage.removeItem(storageKey); } catch (_) {}
    const url = new URL(window.location.href);
    url.searchParams.delete(sourceKey);
    window.history.replaceState(window.history.state, '', url);
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ebook-source-login]');
    if (!link) return;
    const login = new URL(link.href, window.location.origin);
    const target = new URL(login.searchParams.get('return_to'), window.location.origin);
    if (target.origin !== window.location.origin || target.searchParams.get(sourceKey) !== sourceValue) return;
    try {
      localStorage.setItem(storageKey, JSON.stringify({ path: target.pathname, startedAt: Date.now() }));
    } catch (_) {}
  });

  const root = document.querySelector('[data-ebook-kit-source]');
  const sourceLogin = document.querySelector('[data-ebook-source-login]');
  if (root && root.dataset.signedIn !== 'true' && sourceLogin) {
    document.querySelectorAll('a[href]').forEach((link) => {
      const account = new URL(link.href, window.location.origin);
      if (account.origin !== window.location.origin || !['/account', '/account/login', '/customer_authentication/login'].includes(account.pathname)) return;
      link.href = sourceLogin.href;
      link.setAttribute('data-ebook-source-login', '');
      link.setAttribute('data-no-instant', '');
    });
  }
  const url = new URL(window.location.href);
  if (!root || url.searchParams.get(sourceKey) !== sourceValue) return;
  const pending = getPending();
  const age = pending ? Date.now() - pending.startedAt : Infinity;
  if (!pending || pending.path !== root.dataset.productPath || pending.path !== url.pathname || !Number.isFinite(age) || age < 0 || age > maxAge) return;
  if (root.dataset.signedIn !== 'true') return;
  if (root.dataset.marketing !== 'true') {
    root.dataset.status = 'no-consent';
    clearPending();
    return;
  }
  const form = root.querySelector('[data-ebook-kit-form]');
  if (!form) return;
  const error = root.querySelector('[data-ebook-kit-error]');
  const retry = root.querySelector('[data-ebook-kit-retry]');
  let sending = false;
  let completed = false;
  const enroll = async () => {
    if (sending || completed) return;
    sending = true;
    root.dataset.status = 'sending';
    error.hidden = true;
    retry.hidden = true;
    try {
      const body = new FormData(form);
      body.append('host', window.location.href);
      body.append('referrer', document.referrer);
      body.append('search', window.location.search);
      body.append('ckjs_version', '6');
      const response = await fetch(form.action, {
        method: 'POST',
        body,
        headers: { Accept: 'application/json', 'X-CKJS-Version': '6' },
        signal: AbortSignal.timeout(15000)
      });
      if (!response.ok) throw new Error('Enrollment failed');
      const result = await response.json();
      if (result.status !== 'success') throw new Error('Enrollment not accepted');
      completed = true;
      root.dataset.status = 'subscribed';
      clearPending();
    } catch (_) {
      root.dataset.status = 'retry';
      error.hidden = false;
      retry.hidden = false;
    } finally {
      sending = false;
    }
  };
  retry.addEventListener('click', enroll);
  enroll();
})();
